var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _circle, _circle2, _circle3, _g, _rect14, _rect15, _rect16, _rect17, _rect18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdvantages1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 320,
    viewBox: "0 0 420 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85.5156,
    y: 93.7715,
    width: 254.568,
    height: 172.293,
    stroke: "#C6C6C6",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 49,
    width: 265.229,
    height: 200.275,
    fill: "#F1F1F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.4951,
    y: 78.2285,
    width: 252.238,
    height: 166.715,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 211.17,
    y: 100.412,
    width: 82.0621,
    height: 5.9322,
    rx: 2.9661,
    fill: "#F1F1F1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6611,
    y: 172.587,
    width: 44.4915,
    height: 47.4576,
    rx: 5,
    transform: "rotate(-90 80.6611 172.587)",
    fill: "#5236FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6611,
    y: 223.011,
    width: 44.4915,
    height: 47.4576,
    rx: 5,
    transform: "rotate(-90 80.6611 223.011)",
    fill: "#F1F1F1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 136.027,
    y: 172.588,
    width: 44.4915,
    height: 46.4689,
    rx: 5,
    transform: "rotate(-90 136.027 172.588)",
    fill: "#F1F1F1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 136.027,
    y: 223.011,
    width: 44.4915,
    height: 46.4689,
    rx: 5,
    transform: "rotate(-90 136.027 223.011)",
    fill: "#F1F1F1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 190.406,
    y: 172.588,
    width: 44.4915,
    height: 46.4689,
    rx: 5,
    transform: "rotate(-90 190.406 172.588)",
    fill: "#F1F1F1"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 190.406,
    y: 223.011,
    width: 44.4915,
    height: 46.4689,
    rx: 5,
    transform: "rotate(-90 190.406 223.011)",
    fill: "#F1F1F1"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 244.785,
    y: 172.587,
    width: 44.4915,
    height: 47.4576,
    rx: 5,
    transform: "rotate(-90 244.785 172.587)",
    fill: "#F1F1F1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 292.412,
    y: 61.9902,
    width: 16.2385,
    height: 4.33027,
    rx: 2.16513,
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6611,
    y: 96.458,
    width: 46.5504,
    height: 4.33027,
    rx: 2.16513,
    fill: "#F1F1F1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6611,
    y: 104.035,
    width: 46.5504,
    height: 4.33027,
    rx: 2.16513,
    fill: "#F1F1F1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6611,
    y: 111.613,
    width: 25.9816,
    height: 4.33027,
    rx: 2.16513,
    fill: "#F1F1F1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.2015,
    cy: 63.6146,
    r: 2.70642,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.7797,
    cy: 63.6146,
    r: 2.70642,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.3578,
    cy: 63.6146,
    r: 2.70642,
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1043_25609)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.693,
    y: 160.723,
    width: 116.487,
    height: 109.776,
    rx: 15,
    fill: "white"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 234.113,
    width: 57.3446,
    height: 21.7514,
    rx: 10.8757,
    transform: "rotate(-60 278.4 234.113)",
    fill: "#5FFFFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 57.3446,
    height: 21.7514,
    rx: 10.8757,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 296.195 195.327)",
    fill: "#FF46EC",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 265.547,
    y: 177.53,
    width: 47.4576,
    height: 5.9322,
    rx: 2.9661,
    fill: "#F1F1F1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 265.547,
    y: 186.429,
    width: 24.7175,
    height: 5.9322,
    rx: 2.9661,
    fill: "#F1F1F1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 334.756,
    y: 253.66,
    width: 24.7175,
    height: 5.9322,
    rx: 2.9661,
    fill: "#F1F1F1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 353.541,
    y: 179.508,
    width: 5.9322,
    height: 5.9322,
    rx: 2.9661,
    fill: "#F1F1F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1043_25609",
    x: 236.693,
    y: 149.723,
    width: 158.487,
    height: 151.775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700272 0 0 0 0 0.700272 0 0 0 0 0.700272 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1043_25609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1043_25609",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdvantages1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/advantages_1.b5a02ef819947fcad18b438ee1475121.svg";